import httpService from '../Api/http.service';
import { getApiBaseUrl } from 'utils';

const BASE_URL = getApiBaseUrl();
const LOOP_API = `${BASE_URL}/loop`;

const getHuddleAppointments = (payload) =>
  httpService({
    url: `${LOOP_API}/huddle/dashboard`,
    method: 'post',
    data: payload,
  });

const exportHuddleData = (payload) =>
  httpService({
    url: `${LOOP_API}/huddle/export`,
    method: 'post',
    data: payload,
    responseType: 'blob',
  });

const sendCampaign = (payload) =>
  httpService({
    url: `${LOOP_API}/comms/notify`,
    method: 'post',
    data: payload,
  });

const morningHuddleService = {
  getHuddleAppointments,
  exportHuddleData,
  sendCampaign,
};

export default morningHuddleService;
